import React from "react";
import { IAffiliateRates } from "./types";
import { Table, TableScroll } from "./style";

export const FEE_FIELDS = [
  { key: "perp_taker_bps", label: "Perps · taker" },
  { key: "perp_maker_bps", label: "Perps · maker" },
  { key: "option_taker_bps", label: "Options · taker" },
  { key: "option_maker_bps", label: "Options · maker" },
] as const;
export const portalTime = (now?: string) =>
  now ? Date.parse(now) : Date.now();
export const isFullFillWaiver = (policy?: string) =>
  policy === "full_fill_or_none";
export const affiliateError = (error: unknown) =>
  error instanceof Error
    ? error.message
    : "Unable to load affiliate history. Please retry.";
export const dateLabel = (value?: string) => {
  if (!value || value.startsWith("0001-")) return "—";
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return "—";
  return `${date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
    timeZone: "UTC",
  })}, ${date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC",
  })} UTC`;
};
export function AffiliatePersonalFees({
  floors,
  tier,
}: {
  floors: IAffiliateRates;
  tier: string;
}) {
  return (
    <>
      <p>Your personal trading fees are fixed at your {tier} tier floor.</p>
      <TableScroll>
        <Table aria-label="Affiliate personal trading fees">
          <thead>
            <tr>
              <th>Trading fee</th>
              <th>Tier floor</th>
            </tr>
          </thead>
          <tbody>
            {FEE_FIELDS.map(({ key, label }) => (
              <tr key={key}>
                <td>{label}</td>
                <td>{floors[key]} bps</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableScroll>
    </>
  );
}
